import base from './base'

export default {

  // 获取模型列表
  getModuleList(params) {
    return base.get('/ai/module/index', params)
  },

}
